import React from 'react';

// audience 'player': players just see a "Lesson Summary" - never that it came from a recording
const NoteTypeTag = ({ type, size = 'medium', audience = 'coach' }) => {
  if (!type) return null;

  const types = {
    lesson: {
      emoji: '📚',
      label: 'Lesson',
      color: '#3498db',
      gradient: 'linear-gradient(135deg, #2471a3 0%, #1f618d 100%)'
    },
    wisdom: {
      emoji: '💡',
      label: 'Wisdom',
      color: '#9b59b6',
      gradient: 'linear-gradient(135deg, #8e44ad 0%, #7d3c98 100%)'
    },
    pocket_recording: {
      emoji: '🎙️',
      label: 'Recording',
      color: '#16a085',
      gradient: 'linear-gradient(135deg, #117a65 0%, #0e6655 100%)'
    }
  };

  if (audience === 'player' && type === 'pocket_recording') {
    types.pocket_recording = { ...types.pocket_recording, emoji: '📝', label: 'Lesson Summary' };
  }

  const tagData = types[type];
  if (!tagData) return null;

  const sizes = {
    small: { padding: '4px 12px', fontSize: '11px', emojiSize: '14px', height: '24px' },
    medium: { padding: '8px 16px', fontSize: '13px', emojiSize: '16px', height: '32px' }
  };

  const sizeStyle = sizes[size];

  return (
    <div style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      background: tagData.gradient,
      color: 'white',
      padding: sizeStyle.padding,
      // minHeight (not height) + wrapping: the pill grows with its text, so the
      // label always stays inside the coloured background at any viewport width
      minHeight: sizeStyle.height,
      boxSizing: 'border-box',
      maxWidth: '100%',
      borderRadius: '12px',
      fontWeight: '700',
      fontSize: sizeStyle.fontSize,
      boxShadow: `0 3px 12px ${tagData.color}60`,
      border: `2px solid ${tagData.color}`
    }}>
      <span style={{ fontSize: sizeStyle.emojiSize, flexShrink: 0 }}>{tagData.emoji}</span>
      <span style={{ minWidth: 0, lineHeight: 1.2, overflowWrap: 'anywhere' }}>{tagData.label}</span>
    </div>
  );
};

export default NoteTypeTag;